export default "__VITE_ASSET__213261e2__"